<template>
  <div class="buybox-header">
    <ImageField
        v-if="isSecondTurn && product.second_turn_logo"
        class="buybox-header__second-turn-logo"
        :obj="{'url': product.second_turn_logo, 'alt':'Second Turn Logo', 'width': 178, 'height': 25}"
      />
    <ImageField
        v-if="product.brand_collab_logo"
        class="buybox-header__second-turn-logo"
        :obj="{'url': product.brand_collab_logo, 'alt':'Brand collab Logo', 'width': 178, 'height': 25}"
      />

    <div class="buybox-header__title-wrapper">
      <h3 class="buybox-header__title">{{ product.title }}</h3>
      <WishlistCTA
        v-if="showWishlistCTA"
        :product="product"
        :selectedVariantDetails="productForm"
        customClass="buybox-header__pdp-wishlist-cta--mobile"
        :isGreenVariant="true"
      />
    </div>

    <!-- Yotpo reviews -->
    <div class="buybox-header__price-review"  v-if="!isSecondTurn && product.id">
      <div
        data-stio-gtm-id="PDP: Reviews Top"
        class="buybox-header__review-wrapper"
        :aria-roledescription="`Reviews link of product ${product.title}`"
        @click="navigateToReviews"
      >
        <div class="yotpo-widget-instance" data-yotpo-instance-id="498880" :data-yotpo-product-id="product.id"></div>
      </div>
    </div>

    <!-- Description -->
    <div
      v-if="showDescription"
      ref="descriptionRef"
      class="buybox-header__description"
      v-html="product.featured_description_content">
    </div>
  </div>
</template>

<script setup>
  import { onMounted, reactive, ref } from 'vue';
  import WishlistCTA from '../../global/wishlist-cta.vue';
  import ImageField from '../../global/image.vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({}),
    },
    isSecondTurn: {
      type: Boolean,
      default: false,
    },
    productForm: {
      type: Object,
      default: () => ({}),
    },
    showWishlistCTA: {
      type: Boolean,
      default: false,
    },
    showDescription: {
      type: Boolean,
      default: true,
    },
    disableReviewLink: {
      type: Boolean,
      default: false,
    },
    isDesktopScreen: {
      type: Boolean,
      default: false,  
    }
  });

  const emit = defineEmits(['see-description-click']);

  const product = reactive(props.product);
  const descriptionRef = ref(null);

  onMounted(() => {
    appendSeeDescription();
  });

  const appendSeeDescription = () => {
    const container = descriptionRef.value;
    if (!container) return;

    const lastParagraph = container.querySelector('p:last-of-type');
    if (lastParagraph) {
      const button = document.createElement('button');
      button.textContent = 'See Description';
      button.className = 'buybox-header__description-button';

      button.addEventListener('click', () => {
        emit('see-description-click');
      });

      lastParagraph.appendChild(button);
    }
  };

  const navigateToReviews = () => {
    if (props.disableReviewLink) {
      return;
    }

    const el = document.getElementById('reviews');
    if (el) {
      const yOffset = props.isDesktopScreen ? -107 : -74;
      const yPosition = el.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({
        top: yPosition,
        behavior: 'smooth',
      });
    }
  };
</script>
